import type { ValidationSettingsGrpcResult } from '../../../shared/api/grpc/validationGrpcClient';
import type { PcfValidationReport } from '../types';

export type ValidationRuntimeSettings = {
  reconnectGapMarginMillimeters: number;
  defaultReconnectGapMarginMillimeters: number;
  minReconnectGapMarginMillimeters: number;
  maxReconnectGapMarginMillimeters: number;
};

export const DEFAULT_VALIDATION_RUNTIME_SETTINGS: ValidationRuntimeSettings = {
  reconnectGapMarginMillimeters: 20,
  defaultReconnectGapMarginMillimeters: 20,
  minReconnectGapMarginMillimeters: 1,
  maxReconnectGapMarginMillimeters: 50,
};

export function toFinitePositiveNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : null;
}

export function normalizeValidationRuntimeSettings(
  source?: Partial<ValidationSettingsGrpcResult | PcfValidationReport> | null,
  fallback: ValidationRuntimeSettings = DEFAULT_VALIDATION_RUNTIME_SETTINGS
): ValidationRuntimeSettings {
  const values = (source ?? {}) as Record<string, unknown>;
  return {
    reconnectGapMarginMillimeters:
      toFinitePositiveNumber(values.reconnectGapMarginMillimeters) ??
      toFinitePositiveNumber(values.ReconnectGapMarginMillimeters) ??
      fallback.reconnectGapMarginMillimeters,
    defaultReconnectGapMarginMillimeters:
      toFinitePositiveNumber(values.defaultReconnectGapMarginMillimeters) ??
      toFinitePositiveNumber(values.DefaultReconnectGapMarginMillimeters) ??
      fallback.defaultReconnectGapMarginMillimeters,
    minReconnectGapMarginMillimeters:
      toFinitePositiveNumber(values.minReconnectGapMarginMillimeters) ??
      toFinitePositiveNumber(values.MinReconnectGapMarginMillimeters) ??
      fallback.minReconnectGapMarginMillimeters,
    maxReconnectGapMarginMillimeters:
      toFinitePositiveNumber(values.maxReconnectGapMarginMillimeters) ??
      toFinitePositiveNumber(values.MaxReconnectGapMarginMillimeters) ??
      fallback.maxReconnectGapMarginMillimeters,
  };
}
